import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";

import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  fetchLicense,
  resetData,
  selectDataAllCompany,
  selectDataLicense,
  selectId,
  selectLoading,
} from "./licenseSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  formatDate,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Mengimpor ikon dari react-icons
import SVG from "react-inlinesvg";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchRole, selectRole } from "../role/roleSlice";
import MultiSelectAll from "../../utility/MultiSelectAll";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import { fetchUser, selectDataUser } from "../user/userSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

export const LicenseCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataLicese = useSelector(selectDataLicense);
  const dataUser = useSelector(selectDataUser);
  const { SearchBar } = Search;

  const { id } = useParams();

  const [license, setLicense] = useState("");
  const [username, setUsername] = useState("");
  const [sales, setSales] = useState("");

  const [optionsUser, setOptionUser] = useState([]);
  const [optionsLicense, setOptionLicense] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableDataUser, setTableDataUser] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);

  const paramsId = {
    company_license_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      const initData = dataId?.company_license_users?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          name: item.name,
          checked:
            item.last_license_code === dataId.license_code ? true : false,
        };
      });

      const filterData = initData.filter((item) => item.checked === true);

      console.log(initData, "filterData");
      setTableData(initData);
      setSelectedRows(filterData);
    }
  }, [dataId]);

  const handleSave = async () => {
    const params = {
      license_code: dataId.license_code,
      company_license_users: selectedRows.map((item) => {
        return {
          user_id: item.user_id,
          license_code: dataId.license_code,
        };
      }),
    };

    console.log(params, "params");

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "Sales code",
      dataField: "company_sales_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "username",
      dataField: "username",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "sales name",
      dataField: "name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const onSelectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    selected: selectedRows.map((row) => row.no),

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allocationLimit = parseInt(dataId.user_allocation);
        if (rows.length > allocationLimit) {
          showDialog(
            `The selected amount cannot be greater than User Allocation ${allocationLimit}`
          );
          setSelectedRows(rows.slice(0, allocationLimit)); // Only add up to the allocation limit
        } else {
          setSelectedRows(rows);
        }
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        if (selectedRows.length >= parseInt(dataId.user_allocation)) {
          showDialog(
            `The selected amount cannot be greater than user allocation  ${dataId.user_allocation}`
          );
          return false;
        }

        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
      return true;
    },
  };

  console.log(selectedRows, "selectedRows");

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Applied License"
              : "Edit Applied License"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Company</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={
                        id === undefined
                          ? user.company_name
                          : dataId?.company_name
                      }
                      disabled
                    />
                  </Col>
                </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>License Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.license_code}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Valid Until</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={formatDate(dataId?.valid_until)}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Applied License</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.applied_license}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>User Allocation</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.user_allocation}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Valid Days</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.valid_days}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          <ToolkitProvider
            keyField="no"
            data={tableData}
            columns={columns}
            search
          >
            {(props) => (
              <div className="mt-5">
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container ">
                  <BootstrapTable
                    // wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    bordered={true}
                    selectRow={onSelectRow}
                    {...props.baseProps}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>
    </>
  );
};
